import type {
  AccidentReportViewModel,
  VehicleKey,
} from "#accident-statement/schema";
import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";

export interface ReportResult {
  data: AccidentReportViewModel;
  party: VehicleKey;
}

export interface ILoadReportContext {
  report: ReportResult;
  updateReport: Dispatch<SetStateAction<AccidentReportViewModel>>;
  loaded: Date;
  updated: Date;
}

export const LoadReportContext = createContext<ILoadReportContext | null>(null);

export function useLoadReportContext() {
  const context = useContext(LoadReportContext);
  if (!context) throw new Error("No LoadReportContext found!");
  return context;
}
